import api from '~/services/api';

const endPoint = 'stockwriteoffs';

// GET
export const getStockWriteOffs = async (params) => {
  try {
    const { data } = await api.get(`/${endPoint}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createStockWriteOffs = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateStockWriteOffs = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteStockWriteOffs = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};
